import {useMemo} from 'react';

import {EMaskValidation} from 'components/form/utils/field-validation-resolver';
import {IValidationRules} from 'entities/metadata';
import {useGetAppPropertyQuery, useGetAppPropertySettingsListQuery} from 'store/api/app-properties/app-properties.api';

export interface IUseFieldPropertySettingsProps {
    validationRules?: IValidationRules[];
    propertyCode?: string;
    propertyCodeList?: string[];
}

// Маски валидации для которых дополнительно нужны свойства propertySettings из "Настройки приложения"
const PropertySettingsValidation: Record<string, string> = {
    fromPropertyListPassword: EMaskValidation.fromPropertyListPassword,
    fromPropertyListPasswordLength: EMaskValidation.fromPropertyListPasswordLength,
};

export const useFieldPropertySettings = (
    {validationRules, propertyCode, propertyCodeList}: IUseFieldPropertySettingsProps,
) => {
    // Запрос на получение propertySettings произойдет, если свойства используются для валидации
    const isPropertySettingsValidation = useMemo(() => validationRules?.find(
        rule => (rule.mask ? PropertySettingsValidation[rule.mask] : false),
    ), [validationRules]);
    const {data: regularFromProperty} = useGetAppPropertyQuery(
        {propertyCode}, {skip: !propertyCode},
    );
    // propertySettings - объект свойств настройки приложения
    // propertyCodeList - массив кодов свойств, которые нужно получить, задается в метаданных
    const {data: propertySettings} = useGetAppPropertySettingsListQuery({propertyCodeList},
        {skip: !propertyCodeList || !isPropertySettingsValidation});

    return {regularFromProperty, propertySettings};
};
